module.exports = __webpack_public_path__ + "static/media/brand-icons.a046592b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/brand-icons.woff
// module id = ./src/styling/theme/assets/fonts/brand-icons.woff
// module chunks = 0